// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.flask_type_enum */
var FlaskTypeEnum;
(function (FlaskTypeEnum) {
    FlaskTypeEnum["SHAKE_FLASK"] = "SHAKE_FLASK";
    FlaskTypeEnum["SPINNER"] = "SPINNER";
    FlaskTypeEnum["BIOREACTOR"] = "BIOREACTOR";
    FlaskTypeEnum["OTHER"] = "OTHER";
})(FlaskTypeEnum || (FlaskTypeEnum = {}));
;
export default FlaskTypeEnum;
/** Zod schema for flask_type_enum */
export const flaskTypeEnum = z.nativeEnum(FlaskTypeEnum);
//# sourceMappingURL=FlaskTypeEnum.js.map